export default function BackArrow() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Knapp tillbaka"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2929 6.01074L3.64226 12.6614L9.73661 19.8638L11.2634 18.5719L7.15611 13.7178H20V11.7178H7.41421L11.7071 7.42496L10.2929 6.01074Z"
        fill="#FF620F"
      />
    </svg>
  )
}
